import {createSlice} from "@reduxjs/toolkit";

const initialBook = () => {
    const savedBook = JSON.parse(localStorage.getItem("book"));
    return savedBook || {book: [], transactionType: "", customerId: ""};
};

const lendingBookState = createSlice({
    name: "book",
    initialState: initialBook(),
    reducers: {
        addBook: (state, action) => {
            const {book, transactionType, title} = action.payload;
            const updatedBook = {...book, transactionType, title};
            state.book.push(updatedBook);
            localStorage.setItem("book", JSON.stringify(state));
        },
        removeBook: (state, action) => {
            const index = state.book.findIndex(
                (item) => item.stockId === action.payload.stockId
            );
            if (index !== -1) {
                state.book.splice(index, 1);
            }
            localStorage.setItem("book", JSON.stringify(state));
        },
        markUnavailableBooks: (state, action) => {
            const unavailableList = action.payload; // array of stockIds or ISBNs

            state.book = state.book.map((item) => {
                if (unavailableList.includes(item.isbn)) {
                    return {...item, unavailable: true};
                }
                return item;
            });

            localStorage.setItem("book", JSON.stringify(state));
        },
        removeAllBooks: (state, action) => {
            state.book = []
            localStorage.setItem("book", JSON.stringify(state));
        }
    },
});

export const {addBook, removeBook, markUnavailableBooks, removeAllBooks} =
    lendingBookState.actions;
export const bookReducer = lendingBookState.reducer;
